module.exports = __webpack_public_path__ + "static/media/shooni.a43d58a5.jpg";